import angular from 'angular'

export default navbarAccountCtrl

/** @ngInject */
function navbarAccountCtrl($scope, $state) {
    $scope.navAccountCollapsed = true

    $scope.isActive = (state) => $state.is(state)

    $scope.getHeaderHeight = function () {
        let headerHeight = 0
        for (const header of Array.from(angular.element('.stickBelow'))) {
            headerHeight += header.getBoundingClientRect().height
        }
        return headerHeight
    }

    $scope.toogleNavAccountCollapsed = () => {
        $scope.navAccountCollapsed = !$scope.navAccountCollapsed
    }
}



// WEBPACK FOOTER //
// ./src/states/navbarAccount/navbarAccount.js